<template>
  <div>
    <!-- Main content -->
    <section class="content domain-section">
      <div
        class="col-xs-12 accessory-search-form search-form"
      >
        <div class="search-form">
          <form
            class="input-group"
            v-on:submit="preventDefault"
          >
            <input
              type="text"
              name="search"
              v-model="short"
              class="form-control accessory-search-input"
              placeholder="Search short..."
              id="search-plugin"
            >
            <div class="input-group-btn">
              <button
                type="submit"
                class="btn btn-info btn-flat accessory-search-btn"
                v-on:click="fetch"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </form>
          <!-- /.input-group -->
        </div>
      </div>

      <!--accessory list-->
      <div>
        <!--no matching result-->
        <div
          class="accessory-list-default"
          v-show="isShowEmptyList"
        >
          <img
            src="../../../static/img/icon_no_matching_result.svg"
            class="center-block accessory-list-no-matching-img"
          >
          <div class="text-center col-sm-6 col-sm-offset-3">
            <h4
              class="page-404-tips"
            >Sorry, no matching results.</h4>
          </div>
        </div>
        <!--no matching result-->
        <!--search result-->
        <div
          class="accessory-list-overall"
          v-for="item in list"
          v-bind:key="item.id"
        >
          <div>
            <div class="box box-solid">
              <div class="box-header with-border">
                <i class="fa fa-text-width"></i>
                <h3 class="box-title">Domain</h3>
              </div>
              <!-- /.box-header -->
              <div class="box-body">
                <dl class="dl-horizontal">
                  <dt>Short</dt>
                  <dd>{{item.short}}</dd>

                  <dt>Content Type</dt>
                  <dd>{{item.contenttype}}</dd>

                  <dt>Content</dt>
                  <dd>
                    <pre>{{item.content}}</pre>
                  </dd>

                  <dt>Action</dt>
                  <dd>
                    <button
                      class="btn btn-info"
                      data-toggle="modal"
                      v-on:click="handleEdit(item)"
                    >Edit</button>
                  </dd>
                </dl>
              </div>
              <!-- /.box-body -->
            </div>
            <!-- /.box -->
          </div>
        </div>
        <!--search result-->
      </div>
      <!-- /accessory list-->
    </section>
    <!-- /.content -->

    <domain-form-modal
      type="edit"
      :fetch="fetch"
      ref="modalEdit"
    />
    <domain-form-modal
      type="create"
      :fetch="fetch"
      ref="modalCreate"
    />

    <!-- add Agent -->
    <div
      class="add-app-bgcolor dropup"
      v-show="isAdminInApp"
    >
      <button class="add-app-btn" v-on:click="handleCreate">
        <span class="btn add-app">
          <i class="fa fa-plus"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import utils from "../../utils";
import DomainFormModal from "../modules/DomainFormModal";

export default {
  name: "domain",
  components: {
    DomainFormModal
  },
  data() {
    return {
      short: "",
      list: []
    };
  },
  computed: {
    isAdminInApp() {
      return utils.checkIsAppAdmin();
    },
    isShowEmptyList() {
      return !this.list.length;
    }
  },
  methods: {
    async fetch() {
      const short = this.short.trim();
      if (!short) return;
      const list = await api.post({
        path: "/domain/get?_type=json",
        data: { short },
        withLoading: true
      });
      this.list = list || [];
    },
    handleCreate() {
      this.$refs.modalCreate.show();
    },
    handleEdit(item) {
      this.$refs.modalEdit.show(item);
    },
    preventDefault(ev) {
      ev.preventDefault();
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>

<style scoped>
.search-form {
  height: 64px;
  float: none;
}
.domain-section dd {
  padding-top: 4px;
  padding-bottom: 4px;
  color: #8a2be2;
}
.domain-section dt {
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// Domain.vue?08392a9e